import { v4 as uuidv4 } from 'uuid';
import { Environment } from '../../../environment';
import { Api} from '../axioscadastro';

export interface IListagemOperacoes {
  idoperacao: string;
  descricao: string;
  tipooperacao: string;
  tipo: number;
}

export interface IDetalheOperacoes {
  descricao: string;
  tipo: number;
}

type TComTotalCount = {
    data: IListagemOperacoes[];
    totalCount: number;
}

const getAll = async (page = 1, filter = ''): Promise<TComTotalCount | Error> => {
  try {
    const urlRelativa = `/operacoes?page=${page}&limit=${Environment.LIMITE_DE_LINHAS}&filter=${filter}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };}
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
}};

const getAllList = async (id = '', filter = ''): Promise<TComTotalCount| Error> => {
  try {
    const urlRelativa: string = id === '' ?  `/operacoes?limit=${Environment.LIMITE_DE_LINHAS}&filter=${filter}` : `/operacoeslist/${id}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };}
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
}};

const getById = async (id: string): Promise<IDetalheOperacoes | Error> => {
  try {
    const { data } = await Api.get(`/operacoes/${id}`);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao consultar o registro.');
}};

const create = async (dados: IDetalheOperacoes): Promise<string | Error> => {
  try {
    const guuid = uuidv4();
    const { data } = await Api.post<IDetalheOperacoes>('/operacoes',  {idoperacao: guuid, ...dados});
    if (Object.keys(data).length === 0) {
      return guuid;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao criar o registro.');
}};

const updateById = async (id: string, dados: IDetalheOperacoes): Promise<void | Error> => {
  try {
    await Api.put(`/operacoes/${id}`, dados);
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro.');
}};

const deleteById = async (id: string): Promise<void | Error> => {
  try {
    await Api.delete(`/operacoes/${id}`);
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao apagar o registro.');
}};

export const OperacoesService = {
  getAll,
  getAllList,
  create,
  getById,
  updateById,
  deleteById,
};